









































import Translation from '@/mixins/Translation'
import Assets from '@/mixins/Assets'
import BttPopup from '@/components/popup/btt/BttPopup.vue'
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import {DateTime} from 'luxon'
import toDateKor from '@/filters/to-date-kor'
import toHalfKor from '@/filters/to-half-kor'

@Component({
  components: {BttPopup},
  filters: {toDateKor, toHalfKor},
})
export default class AdditionalTaxInfoPopup extends Mixins(Translation, Assets) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: false, type: Boolean}) value: boolean
  @Prop({default: '', type: String}) 가산세유형: string
  @Prop({default: '', type: DateTime}) 작성일자: DateTime
  @Prop({default: '', type: DateTime}) 발행기한: DateTime
  @Prop({default: '', type: DateTime}) 확정신고기한: DateTime
  open: boolean = true
  @Watch('value', {immediate: true})
  __value(value) {
    this.open = value
  }
  @Watch('open', {immediate: true})
  __open(value) {
    this.$emit('input', value)
  }
  close() {
    this.open = false
  }
}
